import { render, staticRenderFns } from "./GlassesFrameEdit.vue?vue&type=template&id=62b730d6&"
import script from "./GlassesFrameEdit.vue?vue&type=script&lang=js&"
export * from "./GlassesFrameEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports